import React from 'react';
import { Button, KIND, SIZE } from 'baseui/button';
import { useNavigate } from 'react-router-dom';

export const ConversationErrorBoundary = ({
  clientId,
}: {
  clientId: string;
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate({ pathname: `/${clientId}/assigned` }, { replace: true });
    window.location.reload();
  };

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Oops!</h2>
      <p>
        Sorry, an unexpected error has occurred. Please click the button below
        to go back to assigned conversations.
      </p>
      <Button
        kind={KIND.secondary}
        size={SIZE.mini}
        overrides={{
          BaseButton: {
            style: () => ({
              width: 'auto',
              height: '40px',
              borderTopLeftRadius: '5px',
              borderBottomLeftRadius: '5px',
              borderTopRightRadius: '5px',
              borderBottomRightRadius: '5px',
              color: '#3693BF',
              backgroundColor: 'white',
              paddingLeft: '2rem',
              paddingRight: '2rem',
              boxShadow: 'rgba(54, 147, 191, 0.23) 0px 0px 5px 0px',
            }),
            props: {
              'data-testid': 'back-to-assigned-conversations-button',
            },
          },
        }}
        onClick={handleBack}
      >
        Back to assigned conversations
      </Button>
    </div>
  );
};
